export default "<p>recent-posts works!</p>\n"